import { AttributesMixin, define, Model, type } from "@type-r/models";
import { BoundPolicyApprovedLimits } from "./boundPolicy";
import { restfulIO } from "./endpoint";
export interface PolicyApprovedLimits extends AttributesMixin<typeof PolicyApprovedLimits> { }
@define
export class PolicyApprovedLimits extends Model {
    static endpoint = restfulIO('api/v1/ingest/invoices/linking/policies');
    static idAttribute = "policyId";

    static attributes = {
        policyId: String,
        approvedLimits : type( [ BoundPolicyApprovedLimits ] ).endpoint(restfulIO('./approvedlimits')).dontSave
        
    };

    
}
